import { Fade, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

export function DraftSavedIndicator({ savedAt }: { savedAt: string | null }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!savedAt) {
      setVisible(false);
      return undefined;
    }
    setVisible(true);
    const timeout = window.setTimeout(() => setVisible(false), 2500);
    return () => window.clearTimeout(timeout);
  }, [savedAt]);

  return (
    <Fade in={visible}>
      <Typography variant="caption" color="success.main" aria-live="polite">
        Draft saved
      </Typography>
    </Fade>
  );
}
